import { useCallback, useEffect, useRef } from 'react';

const SCROLL_TO_ERROR_DELAY_MS = 200;

const useCustomFieldErrorScroll = (setShouldScrollToError, resetDelayMs = SCROLL_TO_ERROR_DELAY_MS) => {
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return useCallback((hasTopLevelErrors) => {
    if (hasTopLevelErrors) return;

    setShouldScrollToError(true);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setShouldScrollToError(false);
      timeoutRef.current = null;
    }, resetDelayMs);
  }, [resetDelayMs, setShouldScrollToError]);
};

export { useCustomFieldErrorScroll };
